export default "__VITE_ASSET__DVmz0ga3__"